export function findFirstDermoscopicImage(registrationData) {
  if (!Array.isArray(registrationData)) return null;

  return (
    registrationData.find((item) => {
      const type = (item.type || '').toLowerCase();
      return type.includes('dermoscopic') && (item.yamlId || item._id);
    }) || null
  );
}

export function hasDermoscopicImages(registrationData) {
  return findFirstDermoscopicImage(registrationData) !== null;
}

export function getRegistrationItemCategory(item) {
  const type = (item?.type || '').toLowerCase();
  if (type.includes('macroscopic')) return 'macroscopic';
  if (type.includes('dermoscopic')) return 'dermoscopic';
  return 'rcm';
}

export function registrationItemHasBounds(item) {
  if (!item) return false;
  const xMin = parseFloat(item.x_min);
  const xMax = parseFloat(item.x_max);
  const yMin = parseFloat(item.y_min);
  const yMax = parseFloat(item.y_max);
  return (
    Number.isFinite(xMin)
    && Number.isFinite(xMax)
    && Number.isFinite(yMin)
    && Number.isFinite(yMax)
    && xMax > xMin
    && yMax > yMin
  );
}

function hasTileSource(item) {
  return Boolean(item?.yamlId || item?._id);
}

/** Macroscopic and dermoscopic rows from registrationData that can load as DZI tiles. */
export function getCoregEligibleImages(registrationData) {
  if (!Array.isArray(registrationData)) {
    return { macroscopic: [], dermoscopic: [] };
  }

  const macroscopic = [];
  const dermoscopic = [];
  registrationData.forEach((item) => {
    if (!hasTileSource(item)) return;
    const category = getRegistrationItemCategory(item);
    if (category === 'macroscopic') macroscopic.push(item);
    else if (category === 'dermoscopic') dermoscopic.push(item);
  });

  return { macroscopic, dermoscopic };
}

export function getCoregImageKey(item) {
  return item?.yamlId || item?._id || item?.itemid || '';
}

export function findCoregImageByKey(images, key) {
  if (!key || !Array.isArray(images)) return null;
  return images.find((item) => getCoregImageKey(item) === key) || null;
}

export function formatCoregImageLabel(item) {
  if (!item) return 'Unknown';

  const parts = [];
  if (item.itemid) parts.push(item.itemid);
  if (item.isic_id && item.isic_id !== item.itemid) parts.push(item.isic_id);
  if (item.description) {
    const desc = item.description.length > 48
      ? `${item.description.slice(0, 45)}…`
      : item.description;
    if (!parts.includes(desc)) parts.push(desc);
  }
  if (parts.length > 0) return parts.join(' · ');

  return item.yamlId || item._id || 'Image';
}
